import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";
const BahrainReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of Bahrain Attestation:</h3>
        <p>
          Embassy certificate attestation is obligatory for Bahrain visas. If
          you are applying for an employment visa or have got an employment
          offer from Bahrain, you are required to submit important documents for
          certification.
        </p>
        <p>
          Embassy certificate attestation in Bahrain is compulsory for obtaining
          work permits. If you are applying Bahrain visa for getting admission
          to any of their educational institutions, you are required to submit
          each of your educational certificates for attestation.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time to get Certificate Attestation for Bahrain:</h3>
        <p>
          The overall time period needed for Bahrain certification attestation
          depends on several factors such as which country you necessitate the
          authentication for, or the sort of documents, or the state you need it
          from. Normally, it will take around a couple of weeks to 25 days to
          accomplish.
        </p>
      </div>
    </div>
  );
};

export default BahrainReqMain;
